module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud04.81c588d1c493636f338415179dfaa15a.png";